// import React from "react";
// import { motion } from "framer-motion";
// import "../../../programs.css";
// import bgImage from "../../../Image/imp1.jpg";
// import AADFAQ from "./AADFAQ";
// import AADCurriculum from "./AADCurriculum";
// import Certificate from "../../Certificate";
// import AADPricing from "./AADPricing";

// export default function WebDevelopment() {
//   return (
//     <>
//       <div className="webdev-bg" style={{ backgroundImage: `url(${bgImage})` }}>
//         <div className="program-detail-main">
//           <h1 className="program-detail-title">Web Development</h1>
//           <p className="program-detail-desc">
//             Build experiences that power the digital world. This course takes
//             you through the essentials of designing and developing modern
//             websites and applications. With businesses across every industry
//             needing strong web infrastructure, web developers remain a
//             foundational part of the global tech workforce.
//           </p>
//           <div className="program-detail-actions">
//             <button className="register-btn">Register Now</button>
//             <button className="expert-btn">Talk To Expert</button>
//           </div>
//         </div>
//       </div>

//       {/* -------------------- Program Overview SECTION -------------------- */}

//       <div className="program-container">
//         <motion.div
//           className="program-left1"
//           initial={{ opacity: 0, x: -100 }}
//           whileInView={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.7 }}
//           viewport={{ once: true }}
//         >
//           <h2 className="program-heading1">Program Overview</h2>
//           <p className="program-description1">
//             This program is designed to help you master the fundamentals of full
//             stack development. You will learn HTML, CSS, JavaScript, React,
//             Node, MongoDB, and deployment skills required to build real-world
//             applications.
//           </p>
//         </motion.div>
//         <motion.form
//           className="program-form"
//           initial={{ opacity: 0, x: 100 }}
//           whileInView={{ opacity: 1, x: 0 }}
//           transition={{ duration: 0.7 }}
//           viewport={{ once: true }}
//         >
//           <h3 className="form-title">Apply Now</h3>

//           <div className="input-group">
//             <label>
//               <i className="fas fa-user"></i> Full Name
//             </label>
//             <input type="text" placeholder="Your answer" required />
//           </div>

//           <div className="input-group">
//             <label>
//               <i className="fas fa-envelope"></i> Email Address
//             </label>
//             <input type="email" placeholder="Your answer" required />
//           </div>

//           <div className="input-group">
//             <label>
//               <i className="fas fa-phone"></i> Phone Number
//             </label>
//             <input
//               type="text"
//               placeholder="+91 xxxxxxxxxx"
//               maxLength="10"
//               required
//             />
//           </div>

//           <div className="input-group">
//             <label>
//               <i className="fas fa-university"></i> College Name
//             </label>
//             <input type="text" placeholder="Your answer" required />
//           </div>

//           <div className="input-group">
//             <label>
//               <i className="fas fa-code"></i> Program
//             </label>
//             <input type="text" value="Web Development" readOnly />
//           </div>

//           <button className="submit-btn">Submit</button>
//         </motion.form>
//       </div>

//       {/* -------------------- NEW SECTION -------------------- */}

//       <AADCurriculum />
//       <Certificate />
//       <AADPricing />
//       <AADFAQ />
//     </>
//   );
// }



import React, { useState } from "react";
import { motion } from "framer-motion";
import "../../../programs.css";
import bgImage from "../../../Image/android.png";
import AADFAQ from "./AADFAQ";
import AADCurriculum from "./AADCurriculum";
import Certificate from "../../Certificate";
import SkillPage from "../../SkillPage";
import AADPricing from "./AADPricing";
import { Link } from "react-router-dom";
export default function WebDevelopment() {
  // form state
  const [form, setForm] = useState({
    fullName: "",
    email: "",
    phone: "",
    college: "",
    program: "AAD ",
  });

  // update state on input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // submit handler - sends to Google Apps Script Web App
  const handleSubmit = async (e) => {
    e.preventDefault();

    const scriptURL = "https://script.google.com/macros/s/AKfycbylqgQCII-mTc7gyy_FJrQ1SyNTds_QSLv9zJO2cf_r3bBqAGfda77B8LA39a_I6gRQ/exec"; 

    try {
      const res = await fetch(scriptURL, {
        method: "POST",
        body: JSON.stringify(form),
      });

      const data = await res.json().catch(() => ({}));

      // Apps Script returns JSON like {status:'success'} as in earlier instructions
      if (data.status === "success" || res.ok) {
        alert("Application submitted successfully!");
        setForm({
          fullName: "",
          email: "",
          phone: "",
          college: "",
          program: "Web Development",
        });
      } else {
        // If Apps Script returns something else, still consider success if HTTP OK
        if (res.ok) {
          alert("Application submitted successfully!");
          setForm({
            fullName: "",
            email: "",
            phone: "",
            college: "",
            program: "Web Development",
          });
        } else {
          console.error("Submit error:", data);
          alert("There was an error submitting the form. Try again later.");
        }
      }
    } catch (err) {
      console.error("Fetch error:", err);
      alert("Network error — please check your connection and try again.");
    }
  };

  return (
    <>
      <div className="webdev-bg" style={{ backgroundImage: `url(${bgImage})` }}>
        <div className="program-detail-main">
          <h1 className="program-detail-title">Web Development</h1>
          <p className="program-detail-desc">
            Build experiences that power the digital world. This course takes
            you through the essentials of designing and developing modern
            websites and applications. With businesses across every industry
            needing strong web infrastructure, web developers remain a
            foundational part of the global tech workforce.
          </p>
          <div className="program-detail-actions">
          <Link to="/register">
                     <button className="register-btn">Register Now</button>
                     </Link>
                     <Link to="/contact-us">
                     <button className="expert-btn">Talk To Expert</button>
                     </Link>
          </div>
        </div>
      </div>

      {/* -------------------- NEW SECTION START -------------------- */}

      <div className="program-container">
        {/* Left side Motion text */}
        <motion.div
          className="program-left1"
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
        >
          <h2 className="program-heading1">Program Overview</h2>
          <p className="program-description1">
            This program is designed to help you master the fundamentals of full
            stack development. You will learn HTML, CSS, JavaScript, React,
            Node, MongoDB, and deployment skills required to build real-world
            applications.
          </p>
        </motion.div>

        {/* Right side Motion Form */}
        <motion.form
          className="program-form"
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          onSubmit={handleSubmit} // submit handler added
        >
          <h3 className="form-title">Apply Now</h3>

          <div className="input-group">
            <label>
              <i className="fas fa-user"></i> Full Name
            </label>
            <input
              type="text"
              name="fullName"
              value={form.fullName}
              onChange={handleChange}
              placeholder="Your answer"
              required
            />
          </div>

          <div className="input-group">
            <label>
              <i className="fas fa-envelope"></i> Email Address
            </label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="Your answer"
              required
            />
          </div>

          <div className="input-group">
            <label>
              <i className="fas fa-phone"></i> Phone Number
            </label>
            <input
              type="text"
              name="phone"
              value={form.phone}
              onChange={handleChange}
              placeholder="+91 xxxxxxxxxx"
              maxLength="10"
              required
            />
          </div>

          <div className="input-group">
            <label>
              <i className="fas fa-university"></i> College Name
            </label>
            <input
              type="text"
              name="college"
              value={form.college}
              onChange={handleChange}
              placeholder="Your answer"
              required
            />
          </div>

          <div className="input-group">
            <label>
              <i className="fas fa-code"></i> Program
            </label>
            <input type="text" name="program" value={form.program} readOnly />
          </div>

          <button className="submit-btn" type="submit">
            Submit
          </button>
        </motion.form>
      </div>

      {/* -------------------- NEW SECTION END -------------------- */}

      <AADCurriculum />
      <SkillPage />
      <Certificate />
      <AADPricing />
      <AADFAQ />
    </>
  );
}
